<template>
    <div>
        <rkm-row>
            <rkm-col>
                <p>
                    As perguntas são direcionadas à pessoa idosa e, quando possível, devem ser confirmadas pelo familiar ou acompanhante, desde
                    que convivam com a pessoa idosa e estejam em condições de responder aos questionamentos. Nas pessoas idosas incapazes de
                    responder, utilizar as respostas do cuidador.
                </p>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-alert>Em geral o tempo de aplicação deste instrumento varia de 5 a 10 minutos.</rkm-alert>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-radio-group
                    @change="handleDesejaPreencherChange"
                    label="Deseja preencher o IVCF 20 para esta pessoa?"
                    v-model="data.model.atendimento.ivcf.desejaPreencher"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Nao</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>

        <template v-if="data.model.atendimento.ivcf.desejaPreencher">
            <rkm-row>
                <rkm-col>
                    <h5>Perguntas do instrumento</h5>
                </rkm-col>
            </rkm-row>

            <rkm-area title="Idade do cidadão | Grupo 1 de 8">
                <rkm-form-input
                    :value="data.model.cidadao.idade"
                    name="pacienteIdade"
                    readonly
                />
            </rkm-area>

            <rkm-area no-margin-top title="Percepção da saúde | Grupo 2 de 8">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.estadoSaudeGeral"
                            label="Em geral, comparando com outras pessoas de sua idade, você diria que sua saúde é"
                            v-model="data.model.atendimento.ivcf.estadoSaudeGeral"
                        >
                            <rkm-form-radio value="excelente_muito_boa_ou_boa">Excelente, muito boa ou boa</rkm-form-radio>
                            <rkm-form-radio value="regular_ou_ruim">Regular ou ruim</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area no-margin-top title="Atividades de vida diária | Grupo 3 de 8">
                <rkm-row>
                    <rkm-col>
                        <strong class="text-info">Atividades de vida diária instrumental</strong>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <p>Por causa de sua saúde ou condição física,</p>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.limitacaoCompras"
                            label="Você deixou de fazer compras?"
                            v-model="data.model.atendimento.ivcf.limitacaoCompras"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não ou não faz compras por outros motivos que não a saúde</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.limitacaoGestaoFinanceira"
                            label="Você deixou de controlar seu dinheiro, gastos ou pagar as contas de sua casa?"
                            v-model="data.model.atendimento.ivcf.limitacaoGestaoFinanceira"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não ou não controla o dinheiro por outros motivos que não a saúde</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.limitacaoTarefasDomesticas"
                            label="Você deixou de realizar pequenos trabalhos domésticos, como lavar a louça, arrumar a casa ou fazer limpeza leve?"
                            v-model="data.model.atendimento.ivcf.limitacaoTarefasDomesticas"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não ou não faz mais pequenos trabalhos domésticos por outros motivos que não a saúde</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <strong class="text-info">Atividades de vida diária básica</strong>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.banhoIndependencia"
                            label="Por causa de sua saúde ou condição física, você deixou de tomar banho sozinho?"
                            v-model="data.model.atendimento.ivcf.banhoIndependencia"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area no-margin-top title="Cognição | Grupo 4 de 8">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.relatoEsquecimentoPorTerceiros"
                            label="Algum familiar ou amigo falou que você está ficando esquecido?"
                            v-model="data.model.atendimento.ivcf.relatoEsquecimentoPorTerceiros"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.esquecimentoPiorando"
                            label="Você tem um esquecimento que está piorando nos últimos meses?"
                            v-model="data.model.atendimento.ivcf.esquecimentoPiorando"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.esquecimentoImpactaAtividades"
                            label="Você tem um esquecimento que está impedindo a realização de alguma atividade do cotidiano?"
                            v-model="data.model.atendimento.ivcf.esquecimentoImpactaAtividades"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area no-margin-top title="Humor | Grupo 5 de 8">
                <rkm-row>
                    <rkm-col>
                        <p>No último mês,</p>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.humorTristezaDesanimo"
                            label="Você ficou com desânimo, tristeza ou desesperança?"
                            v-model="data.model.atendimento.ivcf.humorTristezaDesanimo"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.perdaInteresseAtividades"
                            label="Você perdeu o interesse ou prazer em atividades anteriormente prazerosas?"
                            v-model="data.model.atendimento.ivcf.perdaInteresseAtividades"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area no-margin-top title="Mobilidade | Grupo 6 de 8">
                <rkm-row>
                    <rkm-col>
                        <strong class="text-info">Alcance, preensão e pinça</strong>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.limitacaoElevarBracos"
                            label="Você é incapaz de elevar os braços acima do nível do ombro?"
                            v-model="data.model.atendimento.ivcf.limitacaoElevarBracos"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.limitacaoMotricidadeFina"
                            label="Você é incapaz de manusear ou segurar pequenos objetos?"
                            v-model="data.model.atendimento.ivcf.limitacaoMotricidadeFina"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <strong class="text-info">Capacidade aeróbica e/ou muscular</strong>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.perdaPesoNaoIntencional"
                            label="Você teve perda de peso não intencional de 4,5 kg ou 5% do peso corporal no último ano, 6 kg nos últimos 6 meses ou 3 kg no último mês?"
                            v-model="data.model.atendimento.ivcf.perdaPesoNaoIntencional"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.imcAbaixo22"
                            label="Você tem Índice de Massa Corporal (IMC) menor que 22 kg/m²?"
                            v-model="data.model.atendimento.ivcf.imcAbaixo22"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.panturrilhaAbaixo31"
                            label="Você tem a circunferência (perímetro) da panturrilha menor que 31 centímetros?"
                            v-model="data.model.atendimento.ivcf.panturrilhaAbaixo31"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.marchaLenta4mMaior5s"
                            label="Em um teste de velocidade da marcha, o tempo gasto pela pessoa idosa para percorrer 4 metros é maior do que 5 segundos?"
                            v-model="data.model.atendimento.ivcf.marchaLenta4mMaior5s"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <strong class="text-info">Marcha</strong>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.dificuldadeCaminharImpactoAtividades"
                            label="Você tem dificuldade para caminhar que possa impedir a realização de alguma atividade do cotidiano?"
                            v-model="data.model.atendimento.ivcf.dificuldadeCaminharImpactoAtividades"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.quedasRecorrentes"
                            label="Você teve duas ou mais quedas no último ano?"
                            v-model="data.model.atendimento.ivcf.quedasRecorrentes"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <strong class="text-info">Continência esfincteriana</strong>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.incontinencia"
                            label="Você perde urina ou fezes, sem querer, em algum momento?"
                            v-model="data.model.atendimento.ivcf.incontinencia"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area no-margin-top title="Comunicação | Grupo 7 de 8">
                <rkm-row>
                    <rkm-col>
                        <strong class="text-info">Visão</strong>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.problemaVisaoImpactoAtividades"
                            label="Você tem problemas de visão capazes de impedir a realização de alguma atividade do cotidiano? (É permitido o uso de óculos ou lentes de contato)"
                            v-model="data.model.atendimento.ivcf.problemaVisaoImpactoAtividades"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <strong class="text-info">Audição</strong>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.problemaAudicaoImpactoAtividades"
                            label="Você tem problemas de audição capazes de impedir a realização de alguma atividade do cotidiano? (É permitido o uso de aparelhos de audição)"
                            v-model="data.model.atendimento.ivcf.problemaAudicaoImpactoAtividades"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area no-margin-top title="Comorbidade múltipla | Grupo 8 de 8">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.doencasCronicasMultiplas"
                            label="Você tem cinco ou mais doenças crônicas?"
                            v-model="data.model.atendimento.ivcf.doencasCronicasMultiplas"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.polifarmacia5OuMaisMedicamentos"
                            label="Você faz uso regular de cinco ou mais medicamentos diferentes todos os dias?"
                            v-model="data.model.atendimento.ivcf.polifarmacia5OuMaisMedicamentos"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-radio-group
                            :validations="validations.ivcf.internacaoUltimos6Meses"
                            label="Você teve alguma internação nos últimos 6 meses?"
                            v-model="data.model.atendimento.ivcf.internacaoUltimos6Meses"
                        >
                            <rkm-form-radio :value="true">Sim</rkm-form-radio>
                            <rkm-form-radio :value="false">Não</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <template v-if="pontuacaoIvcf > 0">
                <rkm-area no-margin-top title="Pontuação final do IVCF 20">
                    <rkm-alert
                        v-if="pontuacaoIvcf <= 6"
                        color="success"
                    >
                        Idoso com BAIXO risco de vulnerabilidade Clínico-funcional – IDOSO ROBUSTO
                    </rkm-alert>

                    <rkm-alert
                        v-if="pontuacaoIvcf >= 7 && pontuacaoIvcf <= 14"
                        color="warning"
                    >
                        Idoso com MODERADO risco de vulnerabilidade Clínico-funcional – IDOSO EM RISCO DE FRAGILIZAÇÃO
                    </rkm-alert>

                    <rkm-alert
                        v-if="pontuacaoIvcf >= 15"
                        color="danger"
                    >
                        Idoso com ALTO risco de vulnerabilidade Clínico-funcional – IDOSO FRÁGIL
                    </rkm-alert>
                </rkm-area>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                ivcf: {
                    estadoSaudeGeral: { required: true },
                    limitacaoCompras: { required: true },
                    limitacaoGestaoFinanceira: { required: true },
                    limitacaoTarefasDomesticas: { required: true },
                    banhoIndependencia: { required: true },
                    relatoEsquecimentoPorTerceiros: { required: true },
                    esquecimentoPiorando: { required: true },
                    esquecimentoImpactaAtividades: { required: true },
                    humorTristezaDesanimo: { required: true },
                    perdaInteresseAtividades: { required: true },
                    limitacaoElevarBracos: { required: true },
                    limitacaoMotricidadeFina: { required: true },
                    perdaPesoNaoIntencional: { required: true },
                    imcAbaixo22: { required: true },
                    panturrilhaAbaixo31: { required: true },
                    marchaLenta4mMaior5s: { required: true },
                    dificuldadeCaminharImpactoAtividades: { required: true },
                    quedasRecorrentes: { required: true },
                    incontinencia: { required: true },
                    problemaVisaoImpactoAtividades: { required: true },
                    problemaAudicaoImpactoAtividades: { required: true },
                    doencasCronicasMultiplas: { required: true },
                    polifarmacia5OuMaisMedicamentos: { required: true },
                    internacaoUltimos6Meses: { required: true },
                },
            }
        },
        pontuacaoIvcf() {
            let pontuacao = 0

            if (this.data.model.cidadao.idadeAnos >= 75 && this.data.model.cidadao.idadeAnos <= 84) {
                pontuacao += 1
            }
            else if (this.data.model.cidadao.idadeAnos >= 85) {
                pontuacao += 3
            }

            if (this.data.model.atendimento.ivcf.estadoSaudeGeral === 'regular_ou_ruim') {
                pontuacao += 1
            }

            if (this.data.model.atendimento.ivcf.limitacaoCompras || this.data.model.atendimento.ivcf.limitacaoGestaoFinanceira || this.data.model.atendimento.ivcf.limitacaoTarefasDomesticas) {
                pontuacao += 4
            }

            if (this.data.model.atendimento.ivcf.banhoIndependencia) {
                pontuacao += 6
            }

            if (this.data.model.atendimento.ivcf.relatoEsquecimentoPorTerceiros) {
                pontuacao += 1
            }

            if (this.data.model.atendimento.ivcf.esquecimentoPiorando) {
                pontuacao += 1
            }

            if (this.data.model.atendimento.ivcf.esquecimentoImpactaAtividades) {
                pontuacao += 2
            }

            if (this.data.model.atendimento.ivcf.humorTristezaDesanimo) {
                pontuacao += 2
            }

            if (this.data.model.atendimento.ivcf.perdaInteresseAtividades) {
                pontuacao += 2
            }

            if (this.data.model.atendimento.ivcf.limitacaoElevarBracos) {
                pontuacao += 1
            }

            if (this.data.model.atendimento.ivcf.limitacaoMotricidadeFina) {
                pontuacao += 1
            }

            if (this.data.model.atendimento.ivcf.perdaPesoNaoIntencional || this.data.model.atendimento.ivcf.imcAbaixo22 || this.data.model.atendimento.ivcf.panturrilhaAbaixo31 || this.data.model.atendimento.ivcf.marchaLenta4mMaior5s) {
                pontuacao += 2
            }

            if (this.data.model.atendimento.ivcf.dificuldadeCaminharImpactoAtividades) {
                pontuacao += 2
            }

            if (this.data.model.atendimento.ivcf.quedasRecorrentes) {
                pontuacao += 2
            }

            if (this.data.model.atendimento.ivcf.incontinencia) {
                pontuacao += 2
            }

            if (this.data.model.atendimento.ivcf.problemaVisaoImpactoAtividades) {
                pontuacao += 2
            }

            if (this.data.model.atendimento.ivcf.problemaAudicaoImpactoAtividades) {
                pontuacao += 2
            }

            if (this.data.model.atendimento.ivcf.doencasCronicasMultiplas || this.data.model.atendimento.ivcf.polifarmacia5OuMaisMedicamentos || this.data.model.atendimento.ivcf.internacaoUltimos6Meses) {
                pontuacao += 4
            }

            return pontuacao
        },
    },
    methods: {
        handleDesejaPreencherChange(value) {
            if (value === false) {
                this.showConfirmation(
                    'Deseja realmente descartar os dados já preenchidos do IVFC 20?',
                    async () => {
                        this.data.model.atendimento.ivcf.estadoSaudeGeral = null
                        this.data.model.atendimento.ivcf.limitacaoCompras = null
                        this.data.model.atendimento.ivcf.limitacaoGestaoFinanceira = null
                        this.data.model.atendimento.ivcf.limitacaoTarefasDomesticas = null
                        this.data.model.atendimento.ivcf.banhoIndependencia = null
                        this.data.model.atendimento.ivcf.relatoEsquecimentoPorTerceiros = null
                        this.data.model.atendimento.ivcf.esquecimentoPiorando = null
                        this.data.model.atendimento.ivcf.esquecimentoImpactaAtividades = null
                        this.data.model.atendimento.ivcf.humorTristezaDesanimo = null
                        this.data.model.atendimento.ivcf.perdaInteresseAtividades = null
                        this.data.model.atendimento.ivcf.limitacaoElevarBracos = null
                        this.data.model.atendimento.ivcf.limitacaoMotricidadeFina = null
                        this.data.model.atendimento.ivcf.perdaPesoNaoIntencional = null
                        this.data.model.atendimento.ivcf.imcAbaixo22 = null
                        this.data.model.atendimento.ivcf.panturrilhaAbaixo31 = null
                        this.data.model.atendimento.ivcf.marchaLenta4mMaior5s = null
                        this.data.model.atendimento.ivcf.dificuldadeCaminharImpactoAtividades = null
                        this.data.model.atendimento.ivcf.quedasRecorrentes = null
                        this.data.model.atendimento.ivcf.incontinencia = null
                        this.data.model.atendimento.ivcf.problemaVisaoImpactoAtividades = null
                        this.data.model.atendimento.ivcf.problemaAudicaoImpactoAtividades = null
                        this.data.model.atendimento.ivcf.doencasCronicasMultiplas = null
                        this.data.model.atendimento.ivcf.polifarmacia5OuMaisMedicamentos = null
                        this.data.model.atendimento.ivcf.internacaoUltimos6Meses = null
                    },
                    async () => {
                        this.data.model.atendimento.ivcf.desejaPreencher = true
                    }
                )
            }
        },
    },
    props: {
        data: { type: Object, required: false },
    },
}
</script>